import {extendTheme} from 'native-base';

export const theme = extendTheme({
  breakpoints: {
    base: 0, // 0 - 479
    sm: 480, // 480 - 767
    md: 768, // 768 - 959
    lg: 960, //960 - 1169
    xl: 1170, //1170 - 1439
    '2xl': 1440, // 1440+
  },
  fontSizes: {
    0: 9,
    1: 11,
    2: 12,
    3: 14,
    4: 16,
    5: 18,
    6: 22,
    7: 26,
    8: 30,
    9: 36,
    10: 44,
  },
  lineHeights: {
    '2xs': '1.4em',
    xs: '1.4em',
    sm: '1.4em',
    md: '1.4em',
    lg: '1.4em',
    xl: '1.75em',
    '2xl': '2em',
    '3xl': '2.5em',
    '4xl': '3em',
    '5xl': '4em',
  },
  // Make sure values below matches any of the keys in `fontConfig`
  fonts: {
    heading: 'Montserrat',
    body: 'Open Sans',
  },
  space: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 48,
    8: 64,
    9: 128,
    10: 256,
    11: 512,
  },
  // default settings for each component!
  components: {
    Text: {
      baseStyle: {
        // Updated to 'tuna' color in our theme, since not injected/filled in here.
        color: '#343840',
        lineHeight: '24px',
      },
    },
  },
  colors: {
    black: '#141414',
    shark: '#23242B',
    tuna: '#343840',
    mako: '#454954',
    shuttleGray: '#565D6A',
    paleSky: '#707784',
    silverSand: '#BEC0C5',
    athens: '#F1F1F6',
    ghostWhite: '#F8F8FA',
    white: '#FFFFFF',
    green: '#00C853',
    transparent: 'transparent',
    caesarRewards: '#A41B32',
    richBlack: '#000000',
    darkGray: '#8A8C8E',
    mediumGray: '#D1D3D4',
    lightGray: '#E6E7E8',
    infoLight: '#F0FAFF',
    info: '#0277BD',
    confirmLight: '#E9F1E6',
    confirm: '#3C763D',
    warning: '#D47806',
    warningLight: '#FCF7E0',
    warningDark: '#A85D00',
    error: '#D60000',
    errorLight: '#FBEDED',
    valid: '#00C853',
    inputBorder: '#E2E4E6',
  },
});
